import { z } from 'zod'

export const CreateSurveySchema = z.object({
  trainingId: z.string().uuid('無効な研修IDです。'),
  formsUrl: z.string().url({ message: '有効なFormsのURLを入力してください。' }),
})

export const UpdateSurveyResponseSchema = z.object({
  userId: z.string().uuid('無効なユーザーIDです。'),
  completed: z.boolean(),
})

export type CreateSurveyInput = z.infer<typeof CreateSurveySchema>
export type UpdateSurveyResponseInput = z.infer<typeof UpdateSurveyResponseSchema>
